var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"d-flex justify-space-between py-4"},_vm._l((_vm.data),function(item,index){return _c('v-col',{key:index,staticClass:"pt-0",attrs:{"cols":"12","md":"2"}},[_c('CardReportInfoVue',{attrs:{"color":item.color,"title":item.title,"text":item.text}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }